<div>
<label class="file-chip" for="fileInput">
    Attach Documents
    <mat-icon class="text-orange-500"> insert_drive_file</mat-icon>
  </label> <mat-icon class="pt-[7px] !text-[18px]">add_circle</mat-icon>
  <input type="file" id="fileInput" multiple (change)="onFileSelected($event)" #fileInput hidden>
</div>
  <span *ngIf="selectedFileName">{{ selectedFileName }}</span>
  